export default {"src":"/_next/static/media/logo-14.2b8b7712.svg","height":49,"width":50,"blurWidth":0,"blurHeight":0};